import $ from 'jquery';
import Tab from 'bootstrap/js/dist/tab';
import './edit_booking_modal';

let titleHeight, pageY;

const debounce = require('debounce');

$(() => {
  onceEventListeners();
  setSizingVars();
  scrollToUrlAnchor();
});

const onceEventListeners = () => {
  $(window).on('resize', setSizingVars);
  $(window).on('scroll', debounce(scrollEvent, 200));
  window.addEventListener('hashchange', scrollToUrlAnchor);
};

const setSizingVars = () => {
  pageY = $(window).scrollTop();
  titleHeight = getTitleHeight();
};

const getTitleHeight = () => {
  return $('#facility-details-title').outerHeight();
};

const toggleTab = (contentTarget, scroll = false) => {
  contentTarget.split(',').forEach((selector, index) => {
    let offset = pageY;
    const checkIfScrollToIsFinished = setInterval(() => {
      activateTab(checkIfScrollToIsFinished, selector, contentTarget, offset);
    }, 100);
    setTimeout(function () {
      clearInterval(checkIfScrollToIsFinished);
    }, 3000);
    if (index === 0 && scroll) {
      offset = $(selector).offset().top - titleHeight;
      scrollToOffset(offset);
    }
  });
};

window.toggleTab = toggleTab;

const activateTab = (
  checkIfScrollToIsFinished,
  selector,
  contentTarget,
  offset
) => {
  if (offset >= pageY - titleHeight) {
    clearInterval(checkIfScrollToIsFinished);
    const tempNav = $('<div />', { class: 'nav' });
    tempNav.append($('<a />', { href: selector }));
    const tab = new Tab(tempNav.find('a'));
    tab.show();
    const tabs = $('button[data-action="tab-content#toggle"]');
    tabs.removeClass('active');
    tabs.filter(`[data-content-target='${contentTarget}']`).addClass('active');
  }
};

const scrollToOffset = (offset) => {
  window.scroll(0, offset);
};

const scrollEvent = () => {
  pageY = $(window).scrollTop();
  let activePane = null;
  $('.pane').each((index, pane) => {
    if ($(pane).offset().top - titleHeight - 10 <= pageY || index === 0) {
      activePane = pane;
    }
  });
  const targetActivePane = $('button.active[data-action="tab-content#toggle"]')
    .data('content-target')
    .split(',')[0];
  if (`#${$(activePane).attr('id')}` !== targetActivePane) {
    const $buttonToActivate = $(
      `button[data-action="tab-content#toggle"][data-content-target*=${$(
        activePane
      ).attr('id')}]`
    );
    const contentTarget = $buttonToActivate.attr('data-content-target');
    if (!contentTarget) return;
    toggleTab(contentTarget, false);
  }
};

const scrollToUrlAnchor = () => {
  const { hash, href } = window.location;
  $(`button[data-content-target*='${hash}']`).click();
  history.replaceState({}, document.title, href.split('#')[0]);
};
